import { useSearchParams } from 'react-router-dom';
import { PlaceMap } from '../features/map/PlaceMap';
import { PlaceCard } from '../features/places/PlaceCard';
import { applyFilters, PlaceList } from '../features/places/PlaceList';
import { useSortedPlaces } from '../state/AppData';

export function ExploreView() {
  const places = useSortedPlaces();
  const [params] = useSearchParams();
  const shown = applyFilters(places, params);
  return (
    <div className="layout layout--explore">
      <div className="pane pane--list"><PlaceList places={places} withFilters /></div>
      <div className="pane pane--map"><PlaceMap places={shown} /></div>
      <div className="pane pane--card"><PlaceCard /></div>
    </div>
  );
}
